import * as React from 'react';
import { DatePicker, DayOfWeek } from 'office-ui-fabric-react/lib/DatePicker';
import {MIAPACons} from '../../Utils/MipaConstant';
import Moment from 'react-moment';
import { DateHelper } from '../../Helpers/DateHelper';
export interface IProps{
  datevalue;
  ChangeDate;
  showIcon?:boolean;
}

export default class MIPADatePicker extends React.Component<IProps,{}>{
  
  constructor(props: IProps) {
    
    super(props);  
      
  }
  public render() {
    
    
   let datevalue=this.props.datevalue!='' && this.props.datevalue!=null && (new Date(this.props.datevalue));
    return (        
       
        <React.Fragment>
            <DatePicker
                            value={datevalue}
                              firstDayOfWeek={DayOfWeek.Monday}
                              strings={MIAPACons.DayPickerStrings}
                              showWeekNumbers={true}
                              firstWeekOfYear={1}
                              showMonthPickerAsOverlay={true}
                              placeholder="Please select follow up date"
                              ariaLabel="Please select follow up date"
                              onSelectDate={(val)=>{ 

                                let date = DateHelper.GetDateStringIn_yyyy_mm_dd_format(val)+ "T10:37:00Z";
                                this.props.ChangeDate(date);
                              }}
                            />
                            {(this.props.showIcon==true || this.props.showIcon==null)?(
                              <React.Fragment>
                                <i className="ms-Icon ms-Icon--Calendar"></i>
                                <Moment  format="DD MMM YY">{this.props.datevalue}</Moment>
                              </React.Fragment>
                              
                            ):null}
                        
            </React.Fragment>
      
    );
  }
  

}
